import moment from 'moment';

// Callers are expected to pass DD-MM-YYYY (the Redux search-state date format). A string in
// any other shape — including a valid date in a different format, or a non-zero-padded variant
// like '1-2-2027' — is treated as "unparseable" (strict parsing) and gets replaced with
// today/tomorrow, same as an actually-past date. Non-strict parsing would accept '1-2-2027' as
// valid and let it through unchanged, keeping a malformed value in the search state.
const format = 'DD-MM-YYYY';

function today() {
  return moment().startOf('day');
}

function dateIsPast(date) {
  const mDate = moment(date, format, true);
  return !mDate.isValid() || mDate.diff(today()) < 0;
}

export function departureDateCheck(date) {
  // An empty/missing date (e.g. a deep link with no departs_date param — see
  // TripSelector/paramsToObject) is "nothing was provided," not "something unparseable was
  // provided." Silently defaulting that to today would hide the missing-param bug behind a
  // search the user never asked for; let it through unchanged, same as before this
  // unparseable-date handling existed.
  if (!date) return date;
  if (dateIsPast(date)) {
    return today().format(format);
  }
  return date;
}

export function returnDateCheck(date) {
  if (!date || date === '') {
    return null;
  }

  if (dateIsPast(date)) {
    return today().add(1, 'days').format(format);
  }
  return date;
}
